import React from "react";
import {
  Box,
  Flex,
  Text,
  Icon,
  Divider,
  Stack,
  Badge,
} from "@chakra-ui/react";
import { BadgeCheck, BadgeX, Calendar, Scaling } from "lucide-react";
import ReusableAvatar from "components/Avatar/ReusableAvatar";

const ViewCompartment = ({ compartment }) => {
  if (!compartment) return null;

  return (
    <Flex direction="column" p={8} width="100%">
      {/* Header with Avatar and Basic Info */}
      <Flex justifyContent="space-between" alignItems="center">
        <Flex alignItems="center">
          <ReusableAvatar name={compartment?.compartment_id} />
          <Box>
            <Text fontSize="2xl" fontWeight="bold" display="flex" alignItems="center">
              Compartment {compartment.compartment_id}
              {compartment.status === "Available" && (
                <>
                  <Icon as={BadgeCheck} size={12} color="green.500" stroke="white" ml={1} fill="green.500" />
                  <Text color="green.500" fontWeight="xs" fontSize="13px" ml={1}> Available</Text>
                </>
              )}
              {compartment.status === "Occupied" && (
                <>
                  <Icon as={BadgeX} size={12} color="red.500" stroke="white" ml={1} fill="red.500" />
                  <Text color="red.500" fontWeight="xs" fontSize="13px" ml={1}> Occupied</Text>
                </>
              )}
            </Text>
            <Text fontSize="sm" color="gray.500" mt={1}>
              Size: {compartment.size}
            </Text>
          </Box>
        </Flex>
      </Flex>

      <Flex mt={2} alignItems="center">
        <Icon as={Calendar} size={16} color="gray.500" mr={1} />
        <Text fontSize="sm" color="gray.500" mr={4}>
          Added on: {compartment.added_date || "N/A"}
        </Text>
      </Flex>

      <Divider my={6} />

      {/* Compartment Information */}
      <Box mb={6}>
        <Stack spacing={4}>
          <Flex alignItems="center" border="1px" borderColor="gray.300" borderRadius="md" p={2}>
            <Icon as={Scaling} mr={2} color="gray.400" />
            <Text fontWeight="500" color="gray.500" fontSize="sm">Size: {compartment.size}</Text>
          </Flex>

          <Flex alignItems="center" border="1px" borderColor="gray.300" borderRadius="md" p={2}>
            <Badge colorScheme={compartment.status === "Occupied" ? "red" : "green"} variant="outline" borderRadius="8px" height="20px" px="8px">
              {compartment.status}
            </Badge>
          </Flex>
        </Stack>
      </Box>
    </Flex>
  );
};

export default ViewCompartment;
